<template>
  <div id="app" :scroll="testScroll" class="position-relative">
      <div v-if="loadingPage" class="position-absolute d-flex flex-column align-items-center justify-content-center" style="top: 0; left: 0; width: 100%; height: 100vh; z-index: 9999999; background-color: #ffffff; color: #0C0C0C;">
          <div class="position-relative" style="padding-top: 5px; margin-bottom: 12px;">
              <img src="./assets/static/Brand_ml.png" alt="Katarina di Maladel" style="width: 100%; height: auto;">
              <div class="position-absolute logo-loading-wrapper" :style="{height: loadingPercentInversion + '%'}"></div>
          </div>
          <h3>Loading {{loadingPercent}}%</h3>
      </div>
      <nav id="nav" v-if="navState" class="position-fixed navbar navbar-light justify-content-start" style="top: 0; left: 0; z-index: 10; width: 100%;">
        <div class="d-flex flex-row align-items-center position-relative" style="width: 15%; z-index: 1;">
            <router-link to="/" data-value="Home" class="navbar-brand nav-link router-inactive" style="height: 100%;"><img :src="require('./assets/static/Brand_xl_white.png')" alt="Katarina di Maladel" style="width: auto; height: 60px;"></router-link>
        </div>
        <div class="collapse-icon" data-toggle="collapse" data-target="#navbarSupportedContent">
            <button>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="rgb(255, 255, 255)" viewBox="0 0 16 16">
                    <path d="M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"/>
                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2z"/>
                </svg>
            </button>
        </div>
        <div class="no-collapse-content flex-row align-items-center justify-content-end" style="width: 85%; height: 100%;">
            <router-link style="display:none" class="nav-link" to="/" data-value="Home">{{webData.nav[0]}}</router-link>
            <router-link class="nav-link" to="stancija" data-value="Stancija">{{webData.nav[1]}}</router-link>
            <router-link class="nav-link" to="services" data-value="Services">{{webData.nav[2]}}</router-link>
            <router-link class="nav-link" to="experience" data-value="Experience">{{webData.nav[3]}}</router-link>
            <router-link class="nav-link" to="gallery" data-value="Gallery">{{webData.nav[4]}}</router-link>
            <div class="dropdown">
                <a class="nav-link drop-btn" data-value="Lang">{{$store.getters.getLang}}
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="rgb(255, 255, 255)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                </a>
                <div class="dropdown-content">
                    <a @click="updateLang('eng')">ENG</a>
                    <a @click="updateLang('de')">DE</a>
                    <a @click="updateLang('hrv')">HRV</a>
                </div>
            </div>
            <router-link class="nav-link" to="book" data-value="Contact Us">{{webData.nav[6]}}</router-link>
        </div>

      <div id="navbarSupportedContent" class="collapse navbar-collapse position-absolute" style="top: 0; left: 0; background-color: #f7f7f7; color: #0C0C0C; width: 100%; height: 100vh;">
          <div class="position-relative nav-ova-background d-flex flex-row align-items-center" style="width: 100%; height: 100vh;">
              <ul class="navbar-nav mr-auto text-center" style="color: inherit; padding: 40px 0 40px 0; width: 100%;">
                  <li id="home-link" class="nav-item active">
                      <router-link class="nav-link color-b" to="/" data-value="Home" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[0]}}</router-link>
                  </li>
                  <li id="accommodation-link" class="nav-item active">
                      <router-link class="nav-link color-b" to="stancija" data-value="Stancija" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[1]}}</router-link>
                  </li>
                  <li id="story-link" class="nav-item active">
                      <router-link class="nav-link color-b" to="services" data-value="Services" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[2]}}</router-link>
                  </li>
                  <li id="gallery-link" class="nav-item active">
                      <router-link class="nav-link color-b" to="experience" data-value="Experience" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[3]}}</router-link>
                  </li>
                  <li id="gallery-link" class="nav-item active">
                      <router-link class="nav-link color-b" to="gallery" data-value="Gallery" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[4]}}</router-link>
                  </li>
                  <li class="dropdown nav-item">
                      <a class="nav-link drop-btn drop-btn-mobile color-b" data-value="Lang">{{webData.nav[5]}}
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="rgb(0, 0, 0)" viewBox="0 0 16 16">
                              <path d="M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"/>
                          </svg>
                      </a>
                      <div class="dropdown-content dropdown-content-mobile">
                          <a @click="updateLang('eng')">Eng</a>
                          <a @click="updateLang('de')">De</a>
                          <a @click="updateLang('hrv')">Hrv</a>
                      </div>
                  </li>
                  <li id="contact-link" class="nav-item active">
                      <router-link class="nav-link color-b" to="book" data-value="Contact Us" data-toggle="collapse" data-target="#navbarSupportedContent">{{webData.nav[6]}}</router-link>
                  </li>
              </ul>
          </div>
      </div>
    </nav>
      <transition name="zoomOut" mode="out-in">
          <router-view @user-info="triggerFeedback" @set-nav-state="setNavigationState" @set-lang="updateLang" :web-data-global="webData" :key="webData.key"/>
      </transition>
      <transition name="slideInTop">
          <div v-if="toggleUserFeedback" class="position-fixed user-feedback-wrapper">
              <div class="user-feedback">
                  <p class="m-0">{{userFeedback[feedbackIndex].text}}</p>
              </div>
          </div>
      </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
        navState: true,
        userFeedback: [
            {text: 'Booking inquiry is successfully sent. We will contact you soon!'},
            {text: 'Hmm something isn\'t right. Check required and try again.'}
        ],
        toggleUserFeedback: false,
        feedbackIndex: 0,
        body: null,
        nav: null,
        app: null,

        // LOADING PAGE
        loadingPage: true,
        loadingPercent: 0,
        loadTime: 0,
        interval: null,
        loadingPercentInversion: 100,

        webData: []
    }
  },
  created () {
      // LOADING PAGE
      let perfData = window.performance.timing;
      let estimatedTime = Math.abs(perfData.loadEventEnd - perfData.navigationStart);
      this.loadTime = Number((estimatedTime / 1000) % 60) * 100;
      this.doProgress();

      let body = document.getElementsByTagName('body');
      body[0].onscroll = this.testScroll;
      this.body = body[0];
  },
    beforeMount () {
        this.$store.commit('toggleLang', 'eng');
        this.webData = this.$store.getters.getWebData;
    },
    mounted () {
        this.nav = document.querySelector('#nav');
      },
    watch: {
        loadingPercent (val) {
            if (val >= 100) {
                clearInterval(this.interval);
                this.body.style.overflowY = 'scroll';
                this.loadingPage = false;
            }
        },
        loadingPage (state) {
            if (!state) this.$store.commit('setTitleLoading', true);
            else this.$store.commit('setTitleLoading', false);
        }
    },
    methods: {
        doProgress () {
            let step = this.loadTime / 100;
            this.interval = setInterval(() => {
                this.loadingPercent++;
                this.loadingPercentInversion--;
            }, step);
        },
        testScroll () {
            if (this.nav !== null) {
                let y = this.body.getBoundingClientRect().y;
                if (y < 0)  this.nav.classList.add('navbar-scrolled');
                else    this.nav.classList.remove('navbar-scrolled');
            } else  this.nav = document.querySelector('#nav');

        },
        triggerFeedback (index) {
          this.feedbackIndex = index;
          this.toggleUserFeedback = true;
            setTimeout(() => {
                this.toggleUserFeedback = false;
            }, 4000)
        },
        setNavigationState (state) {
            this.navState = state;
            if (state)  this.nav = document.querySelector('#nav');
        },
        updateLang (state) {
            this.$store.commit('toggleLang', state);
            this.webData = this.$store.getters.getWebData;
            this.$forceUpdate();
        }
    }
}
</script>

<style>
.router-inactive:hover {
    border-bottom: transparent !important; 
}
.router-inactive:visited {
    border-bottom: transparent !important; 
}
.router-inactive {
    border-bottom: transparent !important; 
}
.navbar-light .navbar-brand:focus, .navbar-light .navbar-brand {
    border-bottom: transparent !important; 
}
.navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover {
    border-bottom: transparent !important; 
}
/* Dropdown Button */
.drop-btn {
    padding: 16px;
    border: none;
    line-height: 0;
}
.drop-btn-mobile {
    line-height: initial!important;
}
.dropdown {
    position: relative;
    display: inline-block;
    cursor: pointer;
}
.dropdown-content {
    position: absolute;
    text-align: center;
    top: 100%;
    left: 0;
    width: 100%;
    min-width: 160px;
    perspective: 1000px;
    display: none;
    background-color: #f1f1f1;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    z-index: 1;
    animation: growDown 300ms ease-in-out forwards;
    transform-origin: top center;
}
.dropdown-content.dropdown-content-mobile {
    position: relative;
    box-shadow: none;
    background: transparent;
}
@keyframes growDown {
    0% {transform: scaleY(0)}
    80% {transform: scaleY(1.1)}
    100% {transform: scaleY(1)}
}
.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    transition: background-color 300ms ease-out;
}
.dropdown-content a:hover {
    background-color: rgba(159, 164, 196, .287);
}
.dropdown:hover .dropdown-content {
    display: block;
}
.logo-loading-wrapper {
    top: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    z-index: 10;
}
.p-6-wrapper {
    padding: 5rem;
}
/*******************************************/
@media (min-width: 768px) {
    .collapse-icon {
        display: none;
    }
    .no-collapse-content {
        display: flex;
    }
    .navbar-light .navbar-brand {
        margin-left: 50px;
    }
}
@media (max-width: 768px) {
    .collapse-icon {
        display: block;
        float: right;
    }
    .no-collapse-content {
        display: none;
    }
}
.collapse-icon {
    position: relative;
    width: 85%;
    text-align: right;
    z-index: 999999999999;
}
.collapse-icon button {
    outline: 0;
    background: transparent;
    border: none;
}
.collapse-icon button svg {
    width: 35px;
    height: 35px;
    transition: all 500ms ease-out;
}
.collapse-icon button:hover svg {
    width: 40px;
    height: 40px;
}
.collapse-icon button:focus {
    outline: none;
}
.collapse-icon button:focus svg {
    fill: rgb(0, 0, 0)!important;
    transform: rotateZ(180deg);
}
#app {
    overflow-x: hidden;
}
body {
    overflow-y: hidden;
}
.m-title {
    line-height: 50px;
    z-index: 2;
    text-align: center;
}
.m-title:after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 55%;
    background-color: #98D37C;
    width: 90px;
    height: 2px;
    transform: translateX(-50%);
    z-index: -1;
}
.m-title:before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    background-color: #98D37C;
    width: 70px;
    height: 2px;
    transform: translateX(-50%);
    z-index: -1;
}
html {
    scroll-behavior: smooth;
    scroll-snap-align: center;
}
.navbar-toggler:focus {
    outline: none;
    border: none;
}
.book-btn, .book-btn-type-2, .nav-btn {
    left: 50%;
    bottom: 30px;
    font-size: 16px;
    font-weight: 700;
    padding: 5px;
    text-align: center;
    border: none;
    border-radius: 5px;
    box-shadow: -4px 10px 13px -3px gray;
    transform: translateX(-50%);
}
.book-btn {
    background-color: #9fa4c4;
    background-image: linear-gradient(315deg, #9fa4c4 0%, #9E768F 74%);
}
button.nav-btn {
    height: 100%;
    width: 100%;
    padding: 0;
    transform: none !important;
    box-shadow: none;
}
.book-btn span, .nav-btn span {
    background-color: rgb(225, 216, 191);
    width: 164px;
    padding: 5px 60px;
    overflow: hidden;
    box-shadow: -1px 4px 13px -3px gray inset;
}
button.nav-btn span {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    box-shadow: none;
}
.book-btn span:before, .book-btn-type-2 span:before, .ind-inner-wrapper:before, .nav-btn span:before {
    content: '';
    position: absolute;
    top: 0;
    left: -20px;
    height: 103%;
    width: 0;
    background-color: #9fa4c4;
    background-image: linear-gradient(315deg, #9fa4c4 0%, #9E768F 74%);
    transform: skewX(35deg);
    transition: all 500ms ease-out;
    z-index: 1;
}
button.nav-btn span:before {
    background-image: linear-gradient(315deg, #9fa4c4 30%, #9E768F 74%) !important;
}
button.nav-btn span:before {
    left: -40px;
}
.nav-btn:hover span:before {
    width: 140%;
}
.book-btn span a, .nav-btn span a {
    position: relative;
    background: -webkit-linear-gradient(315deg, #9E768F 0%, #9fa4c4 74%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0;
    transition: all 500ms ease-out;
    z-index: 3;
}
.book-btn:hover span:before, .book-btn-type-2:hover span:before {
    width: 120%;
}
.book-btn:hover span a, .book-btn-type-2:hover span a, .nav-btn:hover span a {
    -webkit-text-fill-color: #f7f7f7;
}
.user-feedback-wrapper {
    left: 0;
    bottom: 0;
    width: 100%;
    padding-bottom: 30px;
    z-index: 999999;
}
.user-feedback {
    width: max-content;
    width: -moz-max-content;
    padding: 25px 120px;
    background-color: #9fa4c4;
    font-size: 18px;
    margin: 0 auto;
}
.user-feedback p {
    color: #f7f7f7;
}
@font-face {
    font-family: 'Dukas';
    src: url('./assets/fonts/duke/DukasCFSemiBold-Regular.ttf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
    font-family: Quentell;
    src: url('./assets/fonts/quentell/QuentellCFSemiBold-Regular.ttf') format('truetype'); /* IE9 Compat Modes */
}

@font-face {
    font-family: 'Seasons';
    src: url('./assets/fonts/seasons/Fontspring-DEMO-theseasons-reg.otf') format('truetype'); /* IE9 Compat Modes */
}

@font-face {
    font-family: 'OPTIwtcGoudy';
    src: url('./assets/fonts/OPTIwtcGoudy/OPTIWTCGOUDY-REGULAR.OTF') format('truetype'); /* IE9 Compat Modes */
}

h1, h2, h3, h4, h5, h6 {
    font-family: "OPTIwtcGoudy";
    line-height: 1.2;
    margin-bottom: .5rem;
}
h1 {
    letter-spacing: 1px;
}
h2 {
    font-size: 45px !important;
}
h3 {
    font-size: 32px !important;
}
h4 {
    font-size: 25px !important;
}
h5 {
    font-size: 18px !important;
}
h6 {
    font-size: 14px !important;
}
@media (min-width: 992px) {
    h1 {
        font-size: 65px !important;
    }
    h2 {
        font-size: 45px !important;
    }
    h3 {
        font-size: 32px !important;
    }
    h4 {
        font-size: 25px !important;
    }
    h5 {
        font-size: 18px !important;
    }
    h6 {
        font-size: 14px !important;
    }
}
@media (max-width: 992px) {
    h1 {
        font-size: 65px !important;
        letter-spacing: 1px;
    }
    h2 {
        font-size: 45px !important;
    }
    h3 {
        font-size: 32px !important;
    }
    h4 {
        font-size: 25px !important;
    }
    h5 {
        font-size: 18px !important;
    }
    h6 {
        font-size: 14px !important;
    }
}
@media (max-width: 768px) {
    h1 {
        font-size: 65px !important;
        letter-spacing: 1px;
    }
    h2 {
        font-size: 45px !important;
    }
    h3 {
        font-size: 32px !important;
    }
    h4 {
        font-size: 25px !important;
    }
    h5 {
        font-size: 18px !important;
    }
    h6 {
        font-size: 14px !important;
    }
}
@media (max-width: 576px) {
    h1 {
        font-size: 50px !important;
        letter-spacing: 1px;
    }
    h2 {
        font-size: 45px !important;
    }
    h3 {
        font-size: 32px !important;
    }
    h4 {
        font-size: 25px !important;
    }
    h5 {
        font-size: 18px !important;
    }
    h6 {
        font-size: 14px !important;
    }
}
@media (max-width: 496px) {
    h1 {
        font-size: 38px !important;
    }
    h2 {
        font-size: 34px !important;
    }
    h4 {
        font-size: 20px !important;
    }
    #footer .copyright-section p, #footer .copyright-section span {
        font-size: 13px;
        line-height: 8px;
    }
    #footer .copyright-section span {
        margin-bottom: 12px;
    }
}
p, small {
    font-family: "OPTIwtcGoudy";
    color: rgba(51, 51, 51, .89);
}
small {
    letter-spacing: 1px;
}
a {
    font-family: Dukas, serif;
    text-transform: uppercase !important;
    letter-spacing: 2px!important;
}
div, span, section {
    display: block;
}
#nav {
    transition: all 400ms ease-out;
}
#nav.navbar-scrolled {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    background-color: #0000007a;
}
.navbar-scrolled .no-collapse-content a.nav-link {
    color: #f7f7f7;
}
.navbar-scrolled .collapse-icon button svg {
    fill: rgb(0, 0, 0)!important;
}
a.nav-link {
    color: #f7f7f7;
    text-transform: capitalize;
    font-size: 13px;
    letter-spacing: 1px;
    font-weight: 400;
    position: relative;
    border-bottom: 2px solid transparent;
    transition: all 400ms ease-out;
}
a.nav-link.color-b:hover, .color-b {
    color: rgb(0, 0, 0)!important;
}
a.nav-link:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 0;
    background-color: #9fa4c4;
    transition: width 400ms ease-out;
}
.navbar-scrolled .no-collapse-content a.nav-link:hover {
    color: inherit!important;
    border-bottom: 2px solid #E1C267;
}
a.nav-link:hover {
    color: #E1C267!important;
    border-bottom: 2px solid #E1C267;
}
a:hover {
    color: inherit!important;
    text-decoration: none!important;
}
a:hover i {
    text-decoration: underline;
}
.router-link-exact-active {
    border-bottom: 2px solid #E1C267!important;
}
.navbar-collapse .nav-ova-background .navbar-nav .nav-item .router-link-exact-active {
    background-color: #E1C267;
    color: rgba(255, 255, 255, .9)!important;
}
.slideInTop-enter-active, .slideInTop-leave-active, .slideInRight-enter-active, .slideInRight-leave-active {
    transition: all 500ms ease-out;
}
.slideInTop-enter, .slideInTop-leave-to {
    bottom: -580px;
}
.slideInTop-enter-to, .slideInTop-leave {
    bottom: 0;
}
.zoomOut-enter-active, .zoomOut-leave-active {
    transition: all 800ms ease-out;
}
.zoomOut-enter, .zoomOut-leave-to {
    transform: translateX(-100%);
}
.zoomOut-enter-to, .zoomOut-leave {
    transform: translateX(0);
}
.fadeIn-enter-active, .fadeIn-leave-active {
    transition: all 300ms ease-out;
}
.fadeIn-enter, .fadeIn-leave-to {
    opacity: 0;
}
.fadeIn-enter-to, .fadeIn-leave {
    opacity: 1;
}
.slideInRight-enter {
    transform: translateX(100%);
    opacity: 0;
}
.slideInRight-enter-to, .slideInRight-leave {
    transform: translateX(0);
    opacity: 1;
}
.slideInRight-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}

</style>
